import React from "react";
import { Container, Row, Col } from "reactstrap";
import appConfig from "../data/appConfig";

const siteTitle = appConfig["siteSet"]["title_c"];
const contactUsLink = appConfig["pageSet"]["contactUsLink"];

const copyrightStart = appConfig["siteSet"]["startYear"];;
const thisDay = new Date();
const copyrightThisYear = thisDay.getFullYear();

const Footer = () => {
	return (
		<Container fluid={true} className="site-footer">
			<Row>
				<Col xs="12">
					<p><span>Buddhist Association of the United States</span><br />
					2020, Route 301, Carmel, NY 10512<br />
					845-225-1819{" "}
					845-228-4283{" "}
					<a href={contactUsLink}>Contact Us</a><br />
					<span>&copy; Copyright  {copyrightStart} -{" "}
					{copyrightThisYear}{" "}{siteTitle}All Rights Reserved
					</span></p>
				</Col>
			</Row>
		</Container>
	);
};

export default Footer;
